<template>
  <v-container class="text-center">
    <v-row align="center">
      <v-col>
        <h1 class="display-2 primary--text">Error 401</h1>
        <p>{{ $t('errorlist.unauthorized') }}</p>
        <v-btn :to="{ name: 'Dashboard' }" color="primary" outlined class="mr-2">
          {{ $t('go-home') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Page401',
};
</script>
